import React from "react";
import { LoginButton } from "../components/Header/buttons/login-button";

export const Login = () => {
  return (
    <div className="content-width-container">
      <h1>Login</h1>
      <p>Log in to access your account.</p>

      <LoginButton className="button button-blue" />
    </div>
  );
};